import PublisherActions from '../../../../actions/PublisherActions';
import UserInfoActions from '../../../../actions/UserInfoActions';
import CustomNotify from '../../../Notify';

export const actions = {
    settingsSave: (state, onSuccess, onError) => (dispatch, getState) => {
        const t = getState().user?.translation || {};
        const notyNames = t.notyMessages || {};
        let params = {
            anonymous: state.anonymous ? '1' : '0',
            subscribed: state.subscribed ? '1' : '0',
            nickname: state.nickname || ' ',
            contacts: JSON.stringify(state.contacts),
        };

        PublisherActions.edit(params).then(data => {
            UserInfoActions.loadInfo();

            CustomNotify(notyNames.update);
            onSuccess && onSuccess();
        }).catch(err => {
            const errorMessage = err?.error?.invalid_parameters || err?.message || 'Произошла ошибка при сохранении';
            onError && onError(errorMessage);
        });
    }
};
